import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { init as UiInit } from '@/utils/ui';
require('@/utils/draggabilly');
import Loading from '@/packages/loading/index.js';
import preLoading from '@/packages/preLoading/index.js';
import DownLoad from '@/packages/downLoad/index.js';
import Toast from '@/packages/toast/index.js';
import Message from '@/packages/message/index.js';
import DialogNotice from '@/packages/dialogNotice/index.js';
import DialogHelp from '@/packages/help/index.js';
import HotGamePush from '@/packages/hotGamePush/index.js';
import SmallGame from '@/packages/smallGame/index.js';
import NewYearScroll from '@/packages/newYearScroll/index.js';
import TouchFullSceen from '@/packages/touchFullSceen/index.js';
import Hour2happy from '@/packages/hour2happy/index.js';
import Couplet from '@/packages/couplet/index.js';
import Tips from '@/packages/tips/index.js';
import directives from '@/utils/directives.js';
import animated from 'animate.css';
// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';
import '@/styles/index.scss'; // global css
import 'swiper/swiper-bundle.css';

Vue.use(directives);
Vue.use(animated);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$preLoading = preLoading.service;
Vue.prototype.$downLoad = DownLoad.service;
Vue.prototype.$toast = Toast.service;
Vue.prototype.$message = Message.service;
Vue.prototype.$dialogNotice = DialogNotice.service;
Vue.prototype.$dialogHelp = DialogHelp.service;
Vue.prototype.$hotGamePush = HotGamePush.service;
Vue.prototype.$smallGame = SmallGame.service;
Vue.prototype.$newYearScroll = NewYearScroll.service;
Vue.prototype.$hour2happy = Hour2happy.service;
Vue.prototype.$couplet = Couplet.service;
Vue.prototype.$touchFullSceen = TouchFullSceen.service;
Vue.prototype.$tips = Tips.service;
Vue.config.productionTip = false;

// import VConsole from 'vconsole';
// new VConsole();

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app');

UiInit();
